function displayedOrders(state) {
	if (state.selectedMapOrderIds && state.selectedMapOrderIds.length > 0) {
		let lookup = new Set(state.selectedMapOrderIds);
		return state.orderSearch.orders.filter(x => lookup.has(x.id));
	}
	if (!state.mapOrderIds || state.mapOrderIds.length === state.orderSearch.orders.length)
		return state.orderSearch.orders;
	let lookup = new Set(state.mapOrderIds);
	return state.orderSearch.orders.filter(x => lookup.has(x.id));
}
function filteredOrders(state, getters) {
	let orders = getters.displayedOrders;
	if (!state.filteredGridOrderIds || state.filteredGridOrderIds.length === 0)
		return orders;

	let lookup = new Set(state.filteredGridOrderIds);
	return orders.filter(x => lookup.has(x.id));
}

export default {
	orderFilter: ({ orderSearch }) => orderSearch.searchFilter,
	tripFilter: ({ tripSearch }) => tripSearch.searchFilter,
	orders: ({ orderSearch }) => orderSearch.orders,
	trips: ({ tripSearch }) => tripSearch.trips,
	tripDetails: ({ tripSearch }) => tripSearch.tripDetails,
	lockMap: ({ orderSearch }) => orderSearch.lockMap,
	ordersLoading: ({ orderSearch }) => orderSearch.ordersLoading,
	tripsLoading: ({ tripSearch }) => tripSearch.tripsLoading,
	selectedOriginalOrder: ({ orderSearch }) => orderSearch.selectedOriginalOrder,
	displayedOrders,
	filteredOrders
};